// CIE-10 — Clasificación Internacional de Enfermedades, 10ª Revisión (español)
// Categorías de 3 caracteres (código + descripción)
const CIE10 = [
  // ── Cap. I: Enfermedades infecciosas y parasitarias (A00–B99) ───────────────
  { code: "A00", label: "Cólera" },
  { code: "A01", label: "Fiebre tifoidea y paratifoidea" },
  { code: "A02", label: "Otras infecciones por Salmonella" },
  { code: "A03", label: "Shigelosis" },
  { code: "A04", label: "Otras infecciones intestinales bacterianas" },
  { code: "A05", label: "Otras intoxicaciones alimentarias bacterianas" },
  { code: "A06", label: "Amebiasis" },
  { code: "A07", label: "Otras enfermedades intestinales debidas a protozoarios" },
  { code: "A08", label: "Infecciones intestinales virales" },
  { code: "A09", label: "Diarrea y gastroenteritis de presunto origen infeccioso" },
  { code: "A15", label: "Tuberculosis respiratoria, confirmada bacteriológicamente" },
  { code: "A16", label: "Tuberculosis respiratoria, sin confirmación bacteriológica" },
  { code: "A17", label: "Tuberculosis del sistema nervioso" },
  { code: "A18", label: "Tuberculosis de otros órganos" },
  { code: "A19", label: "Tuberculosis miliar" },
  { code: "A20", label: "Peste" },
  { code: "A22", label: "Ántrax" },
  { code: "A23", label: "Brucelosis" },
  { code: "A24", label: "Muermo y melioidosis" },
  { code: "A25", label: "Fiebres por mordedura de rata" },
  { code: "A27", label: "Leptospirosis" },
  { code: "A28", label: "Otras enfermedades zoonóticas bacterianas" },
  { code: "A30", label: "Lepra" },
  { code: "A31", label: "Infecciones debidas a otras micobacterias" },
  { code: "A32", label: "Listeriosis" },
  { code: "A33", label: "Tétanos neonatal" },
  { code: "A34", label: "Tétanos obstétrico" },
  { code: "A35", label: "Otros tétanos" },
  { code: "A36", label: "Difteria" },
  { code: "A37", label: "Tos ferina" },
  { code: "A38", label: "Escarlatina" },
  { code: "A39", label: "Infección meningocócica" },
  { code: "A40", label: "Septicemia estreptocócica" },
  { code: "A41", label: "Otras septicemias" },
  { code: "A46", label: "Erisipela" },
  { code: "A48", label: "Otras enfermedades bacterianas" },
  { code: "A49", label: "Infección bacteriana de sitio no especificado" },
  { code: "A50", label: "Sífilis congénita" },
  { code: "A51", label: "Sífilis temprana" },
  { code: "A52", label: "Sífilis tardía" },
  { code: "A53", label: "Otras sífilis y las no especificadas" },
  { code: "A54", label: "Infección gonocócica" },
  { code: "A55", label: "Linfogranuloma (venéreo) por clamidias" },
  { code: "A56", label: "Otras enfermedades de transmisión sexual por clamidias" },
  { code: "A57", label: "Chancro blando" },
  { code: "A59", label: "Tricomoniasis" },
  { code: "A60", label: "Infección anogenital debida a virus del herpes simple" },
  { code: "A63", label: "Otras enfermedades de transmisión predominantemente sexual" },
  { code: "A69", label: "Otras infecciones por espiroquetas" },
  { code: "A70", label: "Infección debida a Chlamydia psittaci" },
  { code: "A74", label: "Otras enfermedades causadas por clamidias" },
  { code: "A75", label: "Tifus" },
  { code: "A77", label: "Fiebre manchada" },
  { code: "A80", label: "Poliomielitis aguda" },
  { code: "A82", label: "Rabia" },
  { code: "A83", label: "Encefalitis viral transmitida por mosquitos" },
  { code: "A84", label: "Encefalitis viral transmitida por garrapatas" },
  { code: "A87", label: "Meningitis viral" },
  { code: "A88", label: "Otras infecciones virales del SNC" },
  { code: "A90", label: "Dengue clásico" },
  { code: "A91", label: "Fiebre hemorrágica debida al virus del dengue" },
  { code: "A92", label: "Otras fiebres virales transmitidas por mosquitos" },
  { code: "A93", label: "Otras fiebres virales transmitidas por artrópodos" },
  { code: "A94", label: "Fiebre viral transmitida por artrópodos, sin otra especificación" },
  { code: "A95", label: "Fiebre amarilla" },
  { code: "A96", label: "Fiebre hemorrágica por arenavirus" },
  { code: "A98", label: "Otras fiebres hemorrágicas virales" },
  { code: "B00", label: "Infecciones debidas al virus del herpes simple" },
  { code: "B01", label: "Varicela" },
  { code: "B02", label: "Herpes zóster" },
  { code: "B03", label: "Viruela" },
  { code: "B04", label: "Infección debida al virus de la viruela de los monos" },
  { code: "B05", label: "Sarampión" },
  { code: "B06", label: "Rubéola" },
  { code: "B07", label: "Verrugas víricas" },
  { code: "B08", label: "Otras infecciones virales con lesiones de piel y membranas mucosas" },
  { code: "B10", label: "Otras infecciones por herpesvirus humanos" },
  { code: "B15", label: "Hepatitis aguda tipo A" },
  { code: "B16", label: "Hepatitis aguda tipo B" },
  { code: "B17", label: "Otras hepatitis virales agudas" },
  { code: "B18", label: "Hepatitis viral crónica" },
  { code: "B19", label: "Hepatitis viral, sin otra especificación" },
  { code: "B20", label: "Enfermedad por VIH con enfermedades infecciosas y parasitarias" },
  { code: "B21", label: "Enfermedad por VIH con tumores malignos" },
  { code: "B22", label: "Enfermedad por VIH con otras enfermedades especificadas" },
  { code: "B23", label: "Enfermedad por VIH con otras afecciones" },
  { code: "B24", label: "Enfermedad por VIH, sin otra especificación" },
  { code: "B25", label: "Enfermedad debida a citomegalovirus" },
  { code: "B26", label: "Parotiditis infecciosa" },
  { code: "B27", label: "Mononucleosis infecciosa" },
  { code: "B30", label: "Conjuntivitis viral" },
  { code: "B34", label: "Infección viral de sitio no especificado" },
  { code: "B35", label: "Dermatofitosis" },
  { code: "B36", label: "Otras micosis superficiales" },
  { code: "B37", label: "Candidiasis" },
  { code: "B38", label: "Coccidioidomicosis" },
  { code: "B39", label: "Histoplasmosis" },
  { code: "B40", label: "Blastomicosis" },
  { code: "B41", label: "Paracoccidioidomicosis" },
  { code: "B42", label: "Esporotricosis" },
  { code: "B44", label: "Aspergilosis" },
  { code: "B45", label: "Criptococosis" },
  { code: "B49", label: "Micosis, sin otra especificación" },
  { code: "B50", label: "Paludismo por Plasmodium falciparum" },
  { code: "B51", label: "Paludismo por Plasmodium vivax" },
  { code: "B54", label: "Paludismo, sin otra especificación" },
  { code: "B55", label: "Leishmaniasis" },
  { code: "B56", label: "Tripanosomiasis africana" },
  { code: "B57", label: "Enfermedad de Chagas" },
  { code: "B65", label: "Esquistosomiasis" },
  { code: "B69", label: "Cisticercosis" },
  { code: "B74", label: "Filariasis" },
  { code: "B76", label: "Anquilostomiasis y necatoriasis" },
  { code: "B77", label: "Ascariasis" },
  { code: "B79", label: "Tricuriasis" },
  { code: "B80", label: "Oxiuriasis" },
  { code: "B82", label: "Parasitosis intestinal, sin otra especificación" },
  { code: "B85", label: "Pediculosis" },
  { code: "B86", label: "Escabiosis" },
  { code: "B99", label: "Otras enfermedades infecciosas" },

  // ── Cap. II: Tumores (C00–D48) ──────────────────────────────────────────────
  { code: "C00", label: "Tumor maligno del labio" },
  { code: "C01", label: "Tumor maligno de la base de la lengua" },
  { code: "C02", label: "Tumor maligno de otras partes de la lengua" },
  { code: "C03", label: "Tumor maligno de la encía" },
  { code: "C04", label: "Tumor maligno del piso de la boca" },
  { code: "C06", label: "Tumor maligno de otras partes de la boca" },
  { code: "C09", label: "Tumor maligno de la amígdala" },
  { code: "C10", label: "Tumor maligno de la orofaringe" },
  { code: "C11", label: "Tumor maligno de la nasofaringe" },
  { code: "C12", label: "Tumor maligno del seno piriforme" },
  { code: "C13", label: "Tumor maligno de la hipofaringe" },
  { code: "C15", label: "Tumor maligno del esófago" },
  { code: "C16", label: "Tumor maligno del estómago" },
  { code: "C17", label: "Tumor maligno del intestino delgado" },
  { code: "C18", label: "Tumor maligno del colon" },
  { code: "C19", label: "Tumor maligno de la unión rectosigmoidea" },
  { code: "C20", label: "Tumor maligno del recto" },
  { code: "C22", label: "Tumor maligno del hígado" },
  { code: "C23", label: "Tumor maligno de la vesícula biliar" },
  { code: "C25", label: "Tumor maligno del páncreas" },
  { code: "C30", label: "Tumor maligno de la cavidad nasal y del oído medio" },
  { code: "C31", label: "Tumor maligno de los senos paranasales" },
  { code: "C32", label: "Tumor maligno de la laringe" },
  { code: "C33", label: "Tumor maligno de la tráquea" },
  { code: "C34", label: "Tumor maligno de los bronquios y del pulmón" },
  { code: "C37", label: "Tumor maligno del timo" },
  { code: "C38", label: "Tumor maligno del corazón, mediastino y pleura" },
  { code: "C40", label: "Tumor maligno de los huesos y cartílagos articulares de los miembros" },
  { code: "C43", label: "Melanoma maligno de la piel" },
  { code: "C44", label: "Otros tumores malignos de la piel" },
  { code: "C45", label: "Mesotelioma" },
  { code: "C46", label: "Sarcoma de Kaposi" },
  { code: "C50", label: "Tumor maligno de la mama" },
  { code: "C53", label: "Tumor maligno del cuello del útero" },
  { code: "C54", label: "Tumor maligno del cuerpo del útero" },
  { code: "C56", label: "Tumor maligno del ovario" },
  { code: "C61", label: "Tumor maligno de la próstata" },
  { code: "C62", label: "Tumor maligno del testículo" },
  { code: "C64", label: "Tumor maligno del riñón" },
  { code: "C67", label: "Tumor maligno de la vejiga urinaria" },
  { code: "C70", label: "Tumor maligno de las meninges" },
  { code: "C71", label: "Tumor maligno del encéfalo" },
  { code: "C73", label: "Tumor maligno de la tiroides" },
  { code: "C80", label: "Tumor maligno de sitio no especificado" },
  { code: "C81", label: "Enfermedad de Hodgkin" },
  { code: "C82", label: "Linfoma no Hodgkin folicular" },
  { code: "C83", label: "Linfoma no Hodgkin difuso" },
  { code: "C85", label: "Linfoma no Hodgkin de otro tipo y el no especificado" },
  { code: "C88", label: "Enfermedades malignas de células plasmáticas" },
  { code: "C90", label: "Mieloma múltiple y tumores malignos de células plasmáticas" },
  { code: "C91", label: "Leucemia linfoide" },
  { code: "C92", label: "Leucemia mieloide" },
  { code: "C95", label: "Leucemia de tipo celular no especificado" },
  { code: "D10", label: "Tumor benigno de la boca y de la faringe" },
  { code: "D12", label: "Tumor benigno del colon, del recto y del conducto anal" },
  { code: "D25", label: "Leiomioma del útero" },
  { code: "D50", label: "Anemia por deficiencia de hierro" },

  // ── Cap. III: Enfermedades de la sangre (D50–D89) ──────────────────────────
  { code: "D51", label: "Anemia por deficiencia de vitamina B12" },
  { code: "D52", label: "Anemia por deficiencia de folatos" },
  { code: "D53", label: "Otras anemias nutricionales" },
  { code: "D55", label: "Anemia debida a trastornos enzimáticos" },
  { code: "D56", label: "Talasemia" },
  { code: "D57", label: "Trastornos falciformes" },
  { code: "D58", label: "Otras anemias hemolíticas hereditarias" },
  { code: "D59", label: "Anemia hemolítica adquirida" },
  { code: "D60", label: "Aplasia adquirida pura de células rojas" },
  { code: "D61", label: "Otras anemias aplásicas" },
  { code: "D62", label: "Anemia posthemorrágica aguda" },
  { code: "D63", label: "Anemia en enfermedades crónicas" },
  { code: "D64", label: "Otras anemias" },
  { code: "D65", label: "Coagulación intravascular diseminada" },
  { code: "D68", label: "Otros defectos de la coagulación" },
  { code: "D69", label: "Púrpura y otras afecciones hemorrágicas" },
  { code: "D70", label: "Agranulocitosis" },
  { code: "D72", label: "Otros trastornos de los leucocitos" },
  { code: "D73", label: "Enfermedades del bazo" },
  { code: "D80", label: "Inmunodeficiencia con predominio de defectos de anticuerpos" },
  { code: "D84", label: "Otras inmunodeficiencias" },
  { code: "D86", label: "Sarcoidosis" },
  { code: "D89", label: "Otros trastornos que afectan el mecanismo inmunitario" },

  // ── Cap. IV: Enfermedades endocrinas (E00–E90) ─────────────────────────────
  { code: "E00", label: "Síndrome de deficiencia congénita de yodo" },
  { code: "E01", label: "Trastornos tiroideos relacionados con deficiencia de yodo" },
  { code: "E02", label: "Hipotiroidismo subclínico por deficiencia de yodo" },
  { code: "E03", label: "Otro hipotiroidismo" },
  { code: "E04", label: "Otros bocios no tóxicos" },
  { code: "E05", label: "Tirotoxicosis (hipertiroidismo)" },
  { code: "E06", label: "Tiroiditis" },
  { code: "E07", label: "Otros trastornos de la tiroides" },
  { code: "E10", label: "Diabetes mellitus tipo 1" },
  { code: "E11", label: "Diabetes mellitus tipo 2" },
  { code: "E12", label: "Diabetes mellitus desnutricional" },
  { code: "E13", label: "Otras diabetes mellitus especificadas" },
  { code: "E14", label: "Diabetes mellitus, sin otra especificación" },
  { code: "E15", label: "Coma hipoglucémico no diabético" },
  { code: "E16", label: "Otros trastornos de la secreción pancreática interna" },
  { code: "E20", label: "Hipoparatiroidismo" },
  { code: "E21", label: "Hiperparatiroidismo y otros trastornos de la paratiroides" },
  { code: "E22", label: "Hiperfunción de la hipófisis" },
  { code: "E23", label: "Hipofunción y otros trastornos de la hipófisis" },
  { code: "E24", label: "Síndrome de Cushing" },
  { code: "E25", label: "Trastornos adrenogenitales" },
  { code: "E26", label: "Hiperaldosteronismo" },
  { code: "E27", label: "Otros trastornos de la glándula suprarrenal" },
  { code: "E28", label: "Disfunción ovárica" },
  { code: "E29", label: "Disfunción testicular" },
  { code: "E34", label: "Otros trastornos endocrinos" },
  { code: "E40", label: "Kwashiorkor" },
  { code: "E41", label: "Marasmo nutricional" },
  { code: "E44", label: "Desnutrición proteico-calórica de grado moderado y leve" },
  { code: "E46", label: "Desnutrición proteico-calórica, sin otra especificación" },
  { code: "E50", label: "Deficiencia de vitamina A" },
  { code: "E53", label: "Deficiencia de otras vitaminas del grupo B" },
  { code: "E55", label: "Deficiencia de vitamina D" },
  { code: "E58", label: "Deficiencia dietética de calcio" },
  { code: "E61", label: "Deficiencia de otros elementos nutricionales" },
  { code: "E63", label: "Otras deficiencias nutricionales" },
  { code: "E65", label: "Adiposidad localizada" },
  { code: "E66", label: "Obesidad" },
  { code: "E70", label: "Trastornos del metabolismo de aminoácidos aromáticos" },
  { code: "E78", label: "Trastornos del metabolismo de las lipoproteínas" },
  { code: "E79", label: "Trastornos del metabolismo de las purinas y pirimidinas" },
  { code: "E80", label: "Trastornos del metabolismo de la porfirina" },
  { code: "E83", label: "Trastornos del metabolismo mineral" },
  { code: "E85", label: "Amiloidosis" },
  { code: "E86", label: "Depleción del volumen" },
  { code: "E87", label: "Otros trastornos de los líquidos, electrólitos y equilibrio ácido-básico" },
  { code: "E88", label: "Otros trastornos metabólicos" },
  { code: "E89", label: "Trastornos endocrinos y metabólicos consecutivos a procedimientos" },
  { code: "E90", label: "Trastornos nutricionales y metabólicos en enfermedades clasificadas" },

  // ── Cap. V: Trastornos mentales y del comportamiento (F00–F99) ──────────────
  { code: "F00", label: "Demencia en la enfermedad de Alzheimer" },
  { code: "F01", label: "Demencia vascular" },
  { code: "F02", label: "Demencia en otras enfermedades clasificadas" },
  { code: "F03", label: "Demencia, sin otra especificación" },
  { code: "F04", label: "Síndrome amnésico orgánico no inducido por alcohol" },
  { code: "F05", label: "Delirio, no inducido por alcohol u otras sustancias" },
  { code: "F06", label: "Otros trastornos mentales debidos a lesión cerebral" },
  { code: "F07", label: "Trastornos de la personalidad y del comportamiento debidos a enfermedades" },
  { code: "F09", label: "Trastorno mental orgánico o sintomático, sin otra especificación" },
  { code: "F10", label: "Trastornos mentales y del comportamiento debidos al uso del alcohol" },
  { code: "F11", label: "Trastornos debidos al uso de opioides" },
  { code: "F12", label: "Trastornos debidos al uso de cannabinoides" },
  { code: "F13", label: "Trastornos debidos al uso de sedantes o hipnóticos" },
  { code: "F14", label: "Trastornos debidos al uso de cocaína" },
  { code: "F15", label: "Trastornos debidos al uso de otros estimulantes" },
  { code: "F17", label: "Trastornos debidos al uso de tabaco" },
  { code: "F19", label: "Trastornos debidos al uso de múltiples drogas" },
  { code: "F20", label: "Esquizofrenia" },
  { code: "F21", label: "Trastorno esquizotípico" },
  { code: "F22", label: "Trastornos delirantes persistentes" },
  { code: "F23", label: "Trastornos psicóticos agudos y transitorios" },
  { code: "F25", label: "Trastornos esquizoafectivos" },
  { code: "F29", label: "Psicosis no orgánica, sin otra especificación" },
  { code: "F30", label: "Episodio maníaco" },
  { code: "F31", label: "Trastorno afectivo bipolar" },
  { code: "F32", label: "Episodio depresivo" },
  { code: "F33", label: "Trastorno depresivo recurrente" },
  { code: "F34", label: "Trastornos del humor (afectivos) persistentes" },
  { code: "F38", label: "Otros trastornos del humor (afectivos)" },
  { code: "F40", label: "Trastornos fóbicos de ansiedad" },
  { code: "F41", label: "Otros trastornos de ansiedad" },
  { code: "F42", label: "Trastorno obsesivo-compulsivo" },
  { code: "F43", label: "Reacción al estrés grave y trastornos de adaptación" },
  { code: "F44", label: "Trastornos disociativos (de conversión)" },
  { code: "F45", label: "Trastornos somatomorfos" },
  { code: "F48", label: "Otros trastornos neuróticos" },
  { code: "F50", label: "Trastornos de la ingestión de alimentos" },
  { code: "F51", label: "Trastornos no orgánicos del sueño" },
  { code: "F54", label: "Factores psicológicos y del comportamiento en enfermedades clasificadas" },
  { code: "F60", label: "Trastornos específicos de la personalidad" },
  { code: "F70", label: "Retraso mental leve" },
  { code: "F71", label: "Retraso mental moderado" },
  { code: "F80", label: "Trastornos específicos del desarrollo del habla y del lenguaje" },
  { code: "F84", label: "Trastornos generalizados del desarrollo" },
  { code: "F90", label: "Trastornos hipercinéticos" },
  { code: "F99", label: "Trastorno mental, sin otra especificación" },

  // ── Cap. VI: Enfermedades del sistema nervioso (G00–G99) ───────────────────
  { code: "G00", label: "Meningitis bacteriana" },
  { code: "G01", label: "Meningitis en enfermedades bacterianas clasificadas" },
  { code: "G02", label: "Meningitis en otras enfermedades infecciosas y parasitarias" },
  { code: "G03", label: "Meningitis debida a otras causas y a las no especificadas" },
  { code: "G04", label: "Encefalitis, mielitis y encefalomielitis" },
  { code: "G06", label: "Absceso y granuloma intracraneales e intraspinales" },
  { code: "G09", label: "Secuelas de enfermedades inflamatorias del sistema nervioso central" },
  { code: "G10", label: "Enfermedad de Huntington" },
  { code: "G11", label: "Ataxia hereditaria" },
  { code: "G12", label: "Atrofia muscular espinal y síndromes relacionados" },
  { code: "G20", label: "Enfermedad de Parkinson" },
  { code: "G21", label: "Parkinsonismo secundario" },
  { code: "G25", label: "Otros trastornos extrapiramidales y del movimiento" },
  { code: "G30", label: "Enfermedad de Alzheimer" },
  { code: "G35", label: "Esclerosis múltiple" },
  { code: "G36", label: "Otras desmielinizaciones diseminadas agudas" },
  { code: "G37", label: "Otras enfermedades desmielinizantes del sistema nervioso central" },
  { code: "G40", label: "Epilepsia" },
  { code: "G41", label: "Estado epiléptico" },
  { code: "G43", label: "Migraña" },
  { code: "G44", label: "Otros síndromes de cefalea" },
  { code: "G45", label: "Ataques de isquemia cerebral transitoria" },
  { code: "G47", label: "Trastornos del sueño" },
  { code: "G50", label: "Trastornos del nervio trigémino" },
  { code: "G51", label: "Trastornos del nervio facial" },
  { code: "G54", label: "Trastornos de las raíces y de los plexos nerviosos" },
  { code: "G55", label: "Compresiones de las raíces y de los plexos nerviosos" },
  { code: "G56", label: "Mononeuropatías del miembro superior" },
  { code: "G57", label: "Mononeuropatías del miembro inferior" },
  { code: "G58", label: "Otras mononeuropatías" },
  { code: "G60", label: "Neuropatía hereditaria e idiopática" },
  { code: "G61", label: "Polineuropatía inflamatoria" },
  { code: "G62", label: "Otras polineuropatías" },
  { code: "G63", label: "Polineuropatía en enfermedades clasificadas" },
  { code: "G70", label: "Miastenia gravis y otros trastornos neuromusculares" },
  { code: "G71", label: "Trastornos primarios de los músculos" },
  { code: "G80", label: "Parálisis cerebral" },
  { code: "G81", label: "Hemiplegia" },
  { code: "G82", label: "Paraplegia y tetraplegia" },
  { code: "G83", label: "Otros síndromes paralíticos" },
  { code: "G89", label: "Trastornos del dolor no clasificados" },
  { code: "G90", label: "Trastornos del sistema nervioso autónomo" },
  { code: "G91", label: "Hidrocefalia" },
  { code: "G92", label: "Encefalopatía tóxica" },
  { code: "G93", label: "Otros trastornos del encéfalo" },
  { code: "G95", label: "Otras enfermedades de la médula espinal" },
  { code: "G99", label: "Otros trastornos del sistema nervioso en enfermedades clasificadas" },

  // ── Cap. VII: Enfermedades del ojo (H00–H59) ───────────────────────────────
  { code: "H00", label: "Orzuelo y calacio" },
  { code: "H01", label: "Otras inflamaciones del párpado" },
  { code: "H02", label: "Otros trastornos del párpado" },
  { code: "H04", label: "Trastornos del aparato lacrimal" },
  { code: "H10", label: "Conjuntivitis" },
  { code: "H11", label: "Otros trastornos de la conjuntiva" },
  { code: "H15", label: "Trastornos de la esclerótica" },
  { code: "H16", label: "Queratitis" },
  { code: "H17", label: "Cicatrices y opacidades de la córnea" },
  { code: "H18", label: "Otros trastornos de la córnea" },
  { code: "H20", label: "Iridociclitis" },
  { code: "H25", label: "Catarata senil" },
  { code: "H26", label: "Otras cataratas" },
  { code: "H27", label: "Otros trastornos del cristalino" },
  { code: "H30", label: "Inflamación coriorretiniana" },
  { code: "H33", label: "Desprendimiento y desgarro de la retina" },
  { code: "H34", label: "Oclusiones vasculares de la retina" },
  { code: "H35", label: "Otros trastornos de la retina" },
  { code: "H40", label: "Glaucoma" },
  { code: "H43", label: "Trastornos del humor vítreo" },
  { code: "H44", label: "Trastornos del globo ocular" },
  { code: "H46", label: "Neuritis óptica" },
  { code: "H47", label: "Otros trastornos del nervio óptico y de las vías ópticas" },
  { code: "H49", label: "Estrabismo paralítico" },
  { code: "H50", label: "Otros estrabismos" },
  { code: "H52", label: "Trastornos de la acomodación y de la refracción" },
  { code: "H53", label: "Alteraciones visuales" },
  { code: "H54", label: "Ceguera y visión reducida" },

  // ── Cap. VIII: Enfermedades del oído (H60–H95) ─────────────────────────────
  { code: "H60", label: "Otitis externa" },
  { code: "H61", label: "Otros trastornos del oído externo" },
  { code: "H65", label: "Otitis media no supurativa" },
  { code: "H66", label: "Otitis media supurativa y la no especificada" },
  { code: "H70", label: "Mastoiditis y afecciones relacionadas" },
  { code: "H71", label: "Colesteatoma del oído medio" },
  { code: "H72", label: "Perforación de la membrana timpánica" },
  { code: "H74", label: "Otros trastornos del oído medio y de la mastoides" },
  { code: "H80", label: "Otosclerosis" },
  { code: "H81", label: "Trastornos de la función vestibular" },
  { code: "H83", label: "Otros trastornos del oído interno" },
  { code: "H90", label: "Hipoacusia conductiva y neurosensorial" },
  { code: "H91", label: "Otras pérdidas del oído" },
  { code: "H92", label: "Otalgia y secreción del oído" },
  { code: "H93", label: "Otros trastornos del oído" },

  // ── Cap. IX: Enfermedades del aparato circulatorio (I00–I99) ───────────────
  { code: "I00", label: "Fiebre reumática sin mención de complicación cardíaca" },
  { code: "I01", label: "Fiebre reumática con complicación cardíaca" },
  { code: "I05", label: "Enfermedades reumáticas de la válvula mitral" },
  { code: "I06", label: "Enfermedades reumáticas de la válvula aórtica" },
  { code: "I10", label: "Hipertensión esencial (primaria)" },
  { code: "I11", label: "Enfermedad cardíaca hipertensiva" },
  { code: "I12", label: "Enfermedad renal hipertensiva" },
  { code: "I13", label: "Enfermedad cardíaca y renal hipertensiva" },
  { code: "I15", label: "Hipertensión secundaria" },
  { code: "I20", label: "Angina de pecho" },
  { code: "I21", label: "Infarto agudo de miocardio" },
  { code: "I22", label: "Infarto subsiguiente de miocardio" },
  { code: "I23", label: "Ciertas complicaciones actuales del infarto agudo de miocardio" },
  { code: "I24", label: "Otras enfermedades isquémicas agudas del corazón" },
  { code: "I25", label: "Enfermedad isquémica crónica del corazón" },
  { code: "I26", label: "Embolia pulmonar" },
  { code: "I27", label: "Otras enfermedades cardiopulmonares" },
  { code: "I30", label: "Pericarditis aguda" },
  { code: "I31", label: "Otras enfermedades del pericardio" },
  { code: "I33", label: "Endocarditis aguda y subaguda" },
  { code: "I34", label: "Trastornos no reumáticos de la válvula mitral" },
  { code: "I35", label: "Trastornos no reumáticos de la válvula aórtica" },
  { code: "I38", label: "Endocarditis, válvula no especificada" },
  { code: "I40", label: "Miocarditis aguda" },
  { code: "I42", label: "Cardiomiopatía" },
  { code: "I44", label: "Bloqueo auriculoventricular y de rama izquierda" },
  { code: "I45", label: "Otros trastornos de la conducción" },
  { code: "I46", label: "Paro cardíaco" },
  { code: "I47", label: "Taquicardia paroxística" },
  { code: "I48", label: "Fibrilación y aleteo auricular" },
  { code: "I49", label: "Otras arritmias cardíacas" },
  { code: "I50", label: "Insuficiencia cardíaca" },
  { code: "I51", label: "Complicaciones y descripciones mal definidas de enfermedad cardíaca" },
  { code: "I60", label: "Hemorragia subaracnoidea" },
  { code: "I61", label: "Hemorragia intracerebral" },
  { code: "I62", label: "Otras hemorragias intracraneales no traumáticas" },
  { code: "I63", label: "Infarto cerebral" },
  { code: "I64", label: "Accidente vascular encefálico agudo, no especificado" },
  { code: "I65", label: "Oclusión y estenosis de arterias precerebrales" },
  { code: "I66", label: "Oclusión y estenosis de arterias cerebrales" },
  { code: "I67", label: "Otras enfermedades cerebrovasculares" },
  { code: "I69", label: "Secuelas de enfermedades cerebrovasculares" },
  { code: "I70", label: "Aterosclerosis" },
  { code: "I71", label: "Aneurisma y disección aórtica" },
  { code: "I72", label: "Otros aneurismas" },
  { code: "I73", label: "Otras enfermedades vasculares periféricas" },
  { code: "I74", label: "Embolia y trombosis arteriales" },
  { code: "I80", label: "Flebitis y tromboflebitis" },
  { code: "I82", label: "Otras embolias y trombosis venosas" },
  { code: "I83", label: "Venas varicosas de los miembros inferiores" },
  { code: "I84", label: "Hemorroides" },
  { code: "I87", label: "Otros trastornos de las venas" },
  { code: "I89", label: "Otros trastornos no infecciosos de los vasos linfáticos" },
  { code: "I95", label: "Hipotensión" },
  { code: "I99", label: "Otros trastornos del aparato circulatorio" },

  // ── Cap. X: Enfermedades del aparato respiratorio (J00–J99) ────────────────
  { code: "J00", label: "Rinofaringitis aguda (resfriado común)" },
  { code: "J01", label: "Sinusitis aguda" },
  { code: "J02", label: "Faringitis aguda" },
  { code: "J03", label: "Amigdalitis aguda" },
  { code: "J04", label: "Laringitis y traqueítis agudas" },
  { code: "J05", label: "Laringitis obstructiva aguda (crup) y epiglotitis" },
  { code: "J06", label: "Infecciones agudas de las vías respiratorias superiores" },
  { code: "J09", label: "Influenza debida a virus identificado de la influenza aviar" },
  { code: "J10", label: "Influenza debida a otro virus de la influenza identificado" },
  { code: "J11", label: "Influenza, virus no identificado" },
  { code: "J12", label: "Neumonía viral, no clasificada" },
  { code: "J13", label: "Neumonía debida a Streptococcus pneumoniae" },
  { code: "J14", label: "Neumonía debida a Haemophilus influenzae" },
  { code: "J15", label: "Neumonía bacteriana, no clasificada" },
  { code: "J16", label: "Neumonía debida a otros microorganismos infecciosos" },
  { code: "J17", label: "Neumonía en enfermedades clasificadas" },
  { code: "J18", label: "Neumonía, sin especificación de microorganismo" },
  { code: "J20", label: "Bronquitis aguda" },
  { code: "J21", label: "Bronquiolitis aguda" },
  { code: "J22", label: "Infección aguda de las vías respiratorias inferiores, sin otra especificación" },
  { code: "J30", label: "Rinitis alérgica y vasomotora" },
  { code: "J31", label: "Rinitis, rinofaringitis y faringitis crónicas" },
  { code: "J32", label: "Sinusitis crónica" },
  { code: "J33", label: "Pólipo nasal" },
  { code: "J34", label: "Otros trastornos de la nariz y de los senos paranasales" },
  { code: "J35", label: "Enfermedades crónicas de las amígdalas y de las adenoides" },
  { code: "J36", label: "Absceso periamigdalino" },
  { code: "J37", label: "Laringitis y laringotraqueítis crónicas" },
  { code: "J38", label: "Enfermedades de las cuerdas vocales y de la laringe" },
  { code: "J39", label: "Otras enfermedades de las vías respiratorias superiores" },
  { code: "J40", label: "Bronquitis no especificada como aguda o crónica" },
  { code: "J41", label: "Bronquitis crónica simple y mucopurulenta" },
  { code: "J42", label: "Bronquitis crónica no especificada" },
  { code: "J43", label: "Enfisema" },
  { code: "J44", label: "Otras enfermedades pulmonares obstructivas crónicas" },
  { code: "J45", label: "Asma" },
  { code: "J46", label: "Estado asmático" },
  { code: "J47", label: "Bronquiectasia" },
  { code: "J60", label: "Neumoconiosis de los mineros del carbón" },
  { code: "J61", label: "Neumoconiosis debida a amianto" },
  { code: "J62", label: "Neumoconiosis debida a polvo de sílice" },
  { code: "J63", label: "Neumoconiosis debida a otros polvos inorgánicos" },
  { code: "J64", label: "Neumoconiosis, sin otra especificación" },
  { code: "J65", label: "Neumoconiosis asociada con tuberculosis" },
  { code: "J66", label: "Enfermedades de las vías aéreas debidas a polvo orgánico específico" },
  { code: "J67", label: "Neumonitis por hipersensibilidad debida al polvo orgánico" },
  { code: "J68", label: "Afecciones respiratorias debidas a inhalación de químicos" },
  { code: "J69", label: "Neumonitis por sólidos y líquidos" },
  { code: "J70", label: "Afecciones respiratorias debidas a otros agentes externos" },
  { code: "J80", label: "Síndrome de dificultad respiratoria del adulto" },
  { code: "J81", label: "Edema pulmonar" },
  { code: "J82", label: "Eosinofilia pulmonar" },
  { code: "J84", label: "Otras enfermedades pulmonares intersticiales" },
  { code: "J85", label: "Absceso del pulmón y del mediastino" },
  { code: "J86", label: "Piotórax" },
  { code: "J90", label: "Derrame pleural" },
  { code: "J91", label: "Derrame pleural en afecciones clasificadas" },
  { code: "J93", label: "Neumotórax" },
  { code: "J94", label: "Otras afecciones pleurales" },
  { code: "J96", label: "Insuficiencia respiratoria, no clasificada" },
  { code: "J98", label: "Otras enfermedades respiratorias" },

  // ── Cap. XI: Enfermedades del aparato digestivo (K00–K93) ──────────────────
  { code: "K00", label: "Trastornos del desarrollo y de la erupción de los dientes" },
  { code: "K01", label: "Dientes incluidos e impactados" },
  { code: "K02", label: "Caries dental" },
  { code: "K03", label: "Otras enfermedades de los tejidos duros de los dientes" },
  { code: "K04", label: "Enfermedades de la pulpa y de los tejidos periapicales" },
  { code: "K05", label: "Gingivitis y enfermedades periodontales" },
  { code: "K08", label: "Otros trastornos de los dientes y sus estructuras de sostén" },
  { code: "K10", label: "Otras enfermedades de los maxilares" },
  { code: "K11", label: "Enfermedades de las glándulas salivales" },
  { code: "K12", label: "Estomatitis y lesiones afines" },
  { code: "K13", label: "Otras enfermedades de los labios y de la mucosa bucal" },
  { code: "K14", label: "Enfermedades de la lengua" },
  { code: "K20", label: "Esofagitis" },
  { code: "K21", label: "Enfermedad por reflujo gastroesofágico" },
  { code: "K22", label: "Otras enfermedades del esófago" },
  { code: "K25", label: "Úlcera gástrica" },
  { code: "K26", label: "Úlcera duodenal" },
  { code: "K27", label: "Úlcera péptica" },
  { code: "K29", label: "Gastritis y duodenitis" },
  { code: "K30", label: "Dispepsia" },
  { code: "K31", label: "Otras enfermedades del estómago y del duodeno" },
  { code: "K35", label: "Apendicitis aguda" },
  { code: "K37", label: "Apendicitis, sin otra especificación" },
  { code: "K38", label: "Otras enfermedades del apéndice" },
  { code: "K40", label: "Hernia inguinal" },
  { code: "K41", label: "Hernia femoral" },
  { code: "K42", label: "Hernia umbilical" },
  { code: "K43", label: "Hernia ventral" },
  { code: "K44", label: "Hernia diafragmática" },
  { code: "K46", label: "Hernia abdominal sin otra especificación" },
  { code: "K50", label: "Enfermedad de Crohn (enteritis regional)" },
  { code: "K51", label: "Colitis ulcerativa" },
  { code: "K52", label: "Otras colitis y gastroenteritis no infecciosas" },
  { code: "K57", label: "Enfermedad diverticular del intestino" },
  { code: "K58", label: "Síndrome del intestino irritable" },
  { code: "K59", label: "Otros trastornos funcionales del intestino" },
  { code: "K60", label: "Fisura y fístula de las regiones anal y rectal" },
  { code: "K62", label: "Otras enfermedades del recto y del ano" },
  { code: "K63", label: "Otras enfermedades del intestino" },
  { code: "K70", label: "Enfermedad hepática alcohólica" },
  { code: "K71", label: "Enfermedad hepática tóxica" },
  { code: "K72", label: "Insuficiencia hepática" },
  { code: "K73", label: "Hepatitis crónica" },
  { code: "K74", label: "Fibrosis y cirrosis del hígado" },
  { code: "K75", label: "Otras enfermedades inflamatorias del hígado" },
  { code: "K76", label: "Otras enfermedades del hígado" },
  { code: "K80", label: "Colelitiasis" },
  { code: "K81", label: "Colecistitis" },
  { code: "K82", label: "Otras enfermedades de la vesícula biliar" },
  { code: "K83", label: "Otras enfermedades de las vías biliares" },
  { code: "K85", label: "Pancreatitis aguda" },
  { code: "K86", label: "Otras enfermedades del páncreas" },
  { code: "K90", label: "Malabsorción intestinal" },
  { code: "K92", label: "Otras enfermedades del aparato digestivo" },

  // ── Cap. XII: Enfermedades de la piel (L00–L99) ────────────────────────────
  { code: "L00", label: "Síndrome estafilocócico de la piel escaldada" },
  { code: "L01", label: "Impétigo" },
  { code: "L02", label: "Absceso cutáneo, furúnculo y carbunco" },
  { code: "L03", label: "Celulitis" },
  { code: "L04", label: "Linfadenitis aguda" },
  { code: "L05", label: "Quiste pilonidal" },
  { code: "L08", label: "Otras infecciones locales de la piel y del tejido subcutáneo" },
  { code: "L10", label: "Pénfigo" },
  { code: "L13", label: "Otras afecciones ampollosas" },
  { code: "L20", label: "Dermatitis atópica" },
  { code: "L21", label: "Dermatitis seborreica" },
  { code: "L22", label: "Dermatitis del pañal" },
  { code: "L23", label: "Dermatitis alérgica de contacto" },
  { code: "L24", label: "Dermatitis de contacto por irritantes" },
  { code: "L25", label: "Dermatitis de contacto, sin otra especificación" },
  { code: "L26", label: "Dermatitis exfoliativa" },
  { code: "L27", label: "Dermatitis debida a sustancias ingeridas" },
  { code: "L28", label: "Liquen simple crónico y prurigo" },
  { code: "L29", label: "Prurito" },
  { code: "L30", label: "Otras dermatitis" },
  { code: "L40", label: "Psoriasis" },
  { code: "L41", label: "Parapsoriasis" },
  { code: "L42", label: "Pitiriasis rosada" },
  { code: "L43", label: "Liquen plano" },
  { code: "L50", label: "Urticaria" },
  { code: "L51", label: "Eritema multiforme" },
  { code: "L52", label: "Eritema nudoso" },
  { code: "L55", label: "Quemadura solar" },
  { code: "L56", label: "Otros cambios agudos de la piel debidos a radiación ultravioleta" },
  { code: "L57", label: "Cambios en la piel debidos a exposición crónica a radiación no ionizante" },
  { code: "L60", label: "Trastornos de las uñas" },
  { code: "L63", label: "Alopecia areata" },
  { code: "L64", label: "Alopecia andrógena" },
  { code: "L65", label: "Otras pérdidas no cicatrizales del pelo" },
  { code: "L70", label: "Acné" },
  { code: "L71", label: "Rosácea" },
  { code: "L72", label: "Quistes foliculares de la piel y del tejido subcutáneo" },
  { code: "L80", label: "Vitíligo" },
  { code: "L81", label: "Otros trastornos de la pigmentación" },
  { code: "L82", label: "Queratosis seborreica" },
  { code: "L84", label: "Callos y callosidades" },
  { code: "L85", label: "Otras formas de engrosamiento epidérmico" },
  { code: "L89", label: "Úlcera de decúbito" },
  { code: "L90", label: "Trastornos atróficos de la piel" },
  { code: "L91", label: "Trastornos hipertróficos de la piel" },
  { code: "L92", label: "Trastornos granulomatosos de la piel y del tejido subcutáneo" },
  { code: "L93", label: "Lupus eritematoso" },
  { code: "L97", label: "Úlcera de miembro inferior, no clasificada" },
  { code: "L98", label: "Otras enfermedades de la piel y del tejido subcutáneo" },

  // ── Cap. XIII: Enfermedades del sistema musculoesquelético (M00–M99) ────────
  { code: "M00", label: "Artritis piógena" },
  { code: "M01", label: "Infecciones articulares directas en enfermedades clasificadas" },
  { code: "M02", label: "Artropatías reactivas" },
  { code: "M05", label: "Artritis reumatoide seropositiva" },
  { code: "M06", label: "Otras artritis reumatoides" },
  { code: "M07", label: "Artropatías psoriásicas y enteropáticas" },
  { code: "M08", label: "Artritis juvenil" },
  { code: "M10", label: "Gota" },
  { code: "M11", label: "Otras artropatías por microcristales" },
  { code: "M12", label: "Otras artropatías específicas" },
  { code: "M13", label: "Otras artritis" },
  { code: "M15", label: "Poliartrosis" },
  { code: "M16", label: "Coxartrosis (artrosis de cadera)" },
  { code: "M17", label: "Gonartrosis (artrosis de rodilla)" },
  { code: "M18", label: "Artrosis de la primera articulación carpometacarpiana" },
  { code: "M19", label: "Otras artrosis" },
  { code: "M20", label: "Deformidades adquiridas de los dedos de la mano" },
  { code: "M21", label: "Otras deformidades adquiridas de los miembros" },
  { code: "M23", label: "Trastornos internos de la rodilla" },
  { code: "M24", label: "Otros trastornos articulares específicos" },
  { code: "M25", label: "Otros trastornos articulares, no clasificados" },
  { code: "M30", label: "Poliarteritis nudosa y afecciones relacionadas" },
  { code: "M32", label: "Lupus eritematoso sistémico" },
  { code: "M33", label: "Dermatopolimiositis" },
  { code: "M34", label: "Esclerosis sistémica" },
  { code: "M35", label: "Otras enfermedades sistémicas del tejido conjuntivo" },
  { code: "M40", label: "Cifosis y lordosis" },
  { code: "M41", label: "Escoliosis" },
  { code: "M42", label: "Osteocondrosis de la columna vertebral" },
  { code: "M43", label: "Otras dorsopatías deformantes" },
  { code: "M45", label: "Espondilitis anquilosante" },
  { code: "M46", label: "Otras enfermedades inflamatorias de la columna vertebral" },
  { code: "M47", label: "Espondilosis" },
  { code: "M48", label: "Otras espondilopatías" },
  { code: "M50", label: "Trastornos del disco cervical" },
  { code: "M51", label: "Otros trastornos de los discos intervertebrales" },
  { code: "M53", label: "Otras dorsopatías, no clasificadas" },
  { code: "M54", label: "Dorsalgia" },
  { code: "M60", label: "Miositis" },
  { code: "M61", label: "Calcificación y osificación del músculo" },
  { code: "M62", label: "Otros trastornos musculares" },
  { code: "M65", label: "Sinovitis y tenosinovitis" },
  { code: "M66", label: "Ruptura espontánea de la sinovial y de tendones" },
  { code: "M67", label: "Otros trastornos de la sinovial y de los tendones" },
  { code: "M70", label: "Trastornos de los tejidos blandos relacionados con el uso, el uso excesivo y la presión" },
  { code: "M71", label: "Otras bursopatías" },
  { code: "M72", label: "Trastornos fibroblásticos" },
  { code: "M75", label: "Lesiones del hombro" },
  { code: "M76", label: "Entesopatías del miembro inferior" },
  { code: "M77", label: "Otras entesopatías" },
  { code: "M79", label: "Otros trastornos de los tejidos blandos, no clasificados" },
  { code: "M80", label: "Osteoporosis con fractura patológica" },
  { code: "M81", label: "Osteoporosis sin fractura patológica" },
  { code: "M84", label: "Trastornos de la continuidad del hueso" },
  { code: "M85", label: "Otros trastornos de la densidad y de la estructura óseas" },
  { code: "M86", label: "Osteomielitis" },
  { code: "M87", label: "Osteonecrosis" },
  { code: "M89", label: "Otros trastornos óseos" },
  { code: "M93", label: "Otras osteocondropatías" },
  { code: "M94", label: "Otros trastornos del cartílago" },
  { code: "M95", label: "Otras deformidades adquiridas del sistema musculoesquelético" },
  { code: "M99", label: "Lesiones biomecánicas, no clasificadas" },

  // ── Cap. XIV: Enfermedades del aparato genitourinario (N00–N99) ─────────────
  { code: "N00", label: "Síndrome nefrítico agudo" },
  { code: "N02", label: "Hematuria recurrente y persistente" },
  { code: "N03", label: "Síndrome nefrítico crónico" },
  { code: "N04", label: "Síndrome nefrótico" },
  { code: "N05", label: "Síndrome nefrítico no especificado" },
  { code: "N10", label: "Nefritis tubulointersticial aguda" },
  { code: "N11", label: "Nefritis tubulointersticial crónica" },
  { code: "N12", label: "Nefritis tubulointersticial, no especificada como aguda o crónica" },
  { code: "N13", label: "Uropatía obstructiva y por reflujo" },
  { code: "N17", label: "Insuficiencia renal aguda" },
  { code: "N18", label: "Insuficiencia renal crónica" },
  { code: "N19", label: "Insuficiencia renal no especificada" },
  { code: "N20", label: "Cálculo del riñón y del uréter" },
  { code: "N21", label: "Cálculo de las vías urinarias inferiores" },
  { code: "N23", label: "Cólico renal, sin otra especificación" },
  { code: "N25", label: "Trastornos resultantes de la función tubular renal alterada" },
  { code: "N28", label: "Otros trastornos del riñón y del uréter" },
  { code: "N30", label: "Cistitis" },
  { code: "N31", label: "Disfunción neuromuscular de la vejiga, no clasificada" },
  { code: "N32", label: "Otros trastornos de la vejiga" },
  { code: "N34", label: "Uretritis y síndrome uretral" },
  { code: "N35", label: "Estenosis uretral" },
  { code: "N39", label: "Otros trastornos del aparato urinario" },
  { code: "N40", label: "Hiperplasia de la próstata" },
  { code: "N41", label: "Enfermedades inflamatorias de la próstata" },
  { code: "N43", label: "Hidrocele y espermatocele" },
  { code: "N44", label: "Torsión del testículo" },
  { code: "N45", label: "Orquitis y epididimitis" },
  { code: "N48", label: "Otros trastornos del pene" },
  { code: "N50", label: "Otros trastornos de los órganos genitales masculinos" },
  { code: "N60", label: "Displasia mamaria benigna" },
  { code: "N61", label: "Trastornos inflamatorios de la mama" },
  { code: "N63", label: "Masa no especificada en la mama" },
  { code: "N70", label: "Salpingitis y ooforitis" },
  { code: "N71", label: "Enfermedad inflamatoria del útero" },
  { code: "N72", label: "Enfermedad inflamatoria del cuello del útero" },
  { code: "N73", label: "Otras enfermedades inflamatorias pélvicas femeninas" },
  { code: "N75", label: "Enfermedades de la glándula de Bartholin" },
  { code: "N76", label: "Otras afecciones inflamatorias de la vagina y de la vulva" },
  { code: "N80", label: "Endometriosis" },
  { code: "N81", label: "Prolapso genital femenino" },
  { code: "N83", label: "Trastornos no inflamatorios del ovario, de la trompa de Falopio y del ligamento ancho" },
  { code: "N85", label: "Otros trastornos no inflamatorios del útero" },
  { code: "N87", label: "Displasia cervical" },
  { code: "N89", label: "Otros trastornos no inflamatorios de la vagina" },
  { code: "N91", label: "Menstruación ausente, escasa y poco frecuente" },
  { code: "N92", label: "Menstruación excesiva, frecuente e irregular" },
  { code: "N93", label: "Otras hemorragias uterinas o vaginales anormales" },
  { code: "N94", label: "Dolor y otras afecciones relacionadas con los órganos genitales femeninos" },
  { code: "N95", label: "Trastornos menopáusicos y perimenopáusicos" },
  { code: "N99", label: "Otros trastornos del aparato genitourinario" },

  // ── Cap. XVIII: Síntomas y signos (R00–R99) ────────────────────────────────
  { code: "R00", label: "Anomalías del latido cardíaco" },
  { code: "R01", label: "Soplos y otros sonidos cardíacos" },
  { code: "R03", label: "Lectura de presión sanguínea anormal, sin diagnóstico" },
  { code: "R04", label: "Hemorragia de las vías respiratorias" },
  { code: "R05", label: "Tos" },
  { code: "R06", label: "Anormalidades de la respiración" },
  { code: "R07", label: "Dolor de garganta y en el pecho" },
  { code: "R09", label: "Otros síntomas y signos que afectan los sistemas circulatorio y respiratorio" },
  { code: "R10", label: "Dolor abdominal y pélvico" },
  { code: "R11", label: "Náusea y vómito" },
  { code: "R12", label: "Pirosis" },
  { code: "R13", label: "Disfagia" },
  { code: "R14", label: "Flatulencia y afecciones relacionadas" },
  { code: "R15", label: "Incontinencia fecal" },
  { code: "R17", label: "Ictericia no especificada" },
  { code: "R18", label: "Ascitis" },
  { code: "R19", label: "Otros síntomas y signos que afectan el aparato digestivo" },
  { code: "R20", label: "Alteraciones de la sensibilidad cutánea" },
  { code: "R21", label: "Erupción y otras erupciones cutáneas no especificadas" },
  { code: "R22", label: "Tumefacción, masa o bulto localizados en piel y tejido subcutáneo" },
  { code: "R25", label: "Movimientos involuntarios anormales" },
  { code: "R26", label: "Anomalías de la marcha y de la movilidad" },
  { code: "R27", label: "Otras dificultades de coordinación" },
  { code: "R29", label: "Otros síntomas y signos que afectan los sistemas nervioso y musculoesquelético" },
  { code: "R30", label: "Dolor asociado con la micción" },
  { code: "R31", label: "Hematuria no especificada" },
  { code: "R32", label: "Incontinencia urinaria no especificada" },
  { code: "R33", label: "Retención de orina" },
  { code: "R35", label: "Poliuria" },
  { code: "R39", label: "Otros síntomas y signos que afectan el aparato urinario" },
  { code: "R41", label: "Otros síntomas y signos que afectan las funciones cognoscitivas y la conciencia" },
  { code: "R42", label: "Mareo y desvanecimiento" },
  { code: "R43", label: "Alteraciones del olfato y del gusto" },
  { code: "R44", label: "Otros síntomas y signos que afectan las sensaciones y percepciones generales" },
  { code: "R45", label: "Síntomas y signos que afectan el estado emocional" },
  { code: "R47", label: "Alteraciones del habla" },
  { code: "R50", label: "Fiebre de otro origen y de origen desconocido" },
  { code: "R51", label: "Cefalea" },
  { code: "R52", label: "Dolor, no clasificado" },
  { code: "R53", label: "Malestar y fatiga" },
  { code: "R54", label: "Senilidad" },
  { code: "R55", label: "Síncope y colapso" },
  { code: "R56", label: "Convulsiones, no clasificadas" },
  { code: "R57", label: "Choque, no clasificado" },
  { code: "R58", label: "Hemorragia, no clasificada" },
  { code: "R59", label: "Ganglios linfáticos aumentados de tamaño" },
  { code: "R60", label: "Edema, no clasificado" },
  { code: "R61", label: "Hiperhidrosis" },
  { code: "R62", label: "Retardo del desarrollo normal esperado" },
  { code: "R63", label: "Síntomas y signos que afectan la ingestión de alimentos y líquidos" },
  { code: "R65", label: "Síndrome de respuesta inflamatoria sistémica" },
  { code: "R68", label: "Otros síntomas y signos generales" },
  { code: "R73", label: "Glucosa sanguínea elevada" },
  { code: "R74", label: "Valores anormales de enzimas en suero" },
  { code: "R79", label: "Otros hallazgos anormales en química sanguínea" },

  // ── Cap. XIX: Traumatismos (S00–T98) ───────────────────────────────────────
  { code: "S00", label: "Traumatismo superficial de la cabeza" },
  { code: "S01", label: "Herida de la cabeza" },
  { code: "S02", label: "Fractura del cráneo y de los huesos de la cara" },
  { code: "S06", label: "Traumatismo intracraneal" },
  { code: "S09", label: "Otros traumatismos de la cabeza y los no especificados" },
  { code: "S10", label: "Traumatismo superficial del cuello" },
  { code: "S12", label: "Fractura del cuello" },
  { code: "S13", label: "Luxación y esguince de articulaciones del cuello" },
  { code: "S20", label: "Traumatismo superficial del tórax" },
  { code: "S22", label: "Fractura de costillas, esternón y columna dorsal" },
  { code: "S27", label: "Traumatismo de otros órganos intratorácicos" },
  { code: "S30", label: "Traumatismo superficial del abdomen, de la región lumbosacra y pelvis" },
  { code: "S32", label: "Fractura de la columna lumbar y de la pelvis" },
  { code: "S40", label: "Traumatismo superficial del hombro y del brazo" },
  { code: "S42", label: "Fractura del hombro y del brazo" },
  { code: "S43", label: "Luxación y esguince de articulaciones del hombro" },
  { code: "S46", label: "Traumatismo de músculo y tendón a nivel del hombro y brazo" },
  { code: "S50", label: "Traumatismo superficial del antebrazo" },
  { code: "S52", label: "Fractura del antebrazo" },
  { code: "S60", label: "Traumatismo superficial de la muñeca y de la mano" },
  { code: "S62", label: "Fractura a nivel de la muñeca y de la mano" },
  { code: "S70", label: "Traumatismo superficial de la cadera y del muslo" },
  { code: "S72", label: "Fractura del fémur" },
  { code: "S73", label: "Luxación y esguince de la cadera" },
  { code: "S80", label: "Traumatismo superficial de la pierna" },
  { code: "S82", label: "Fractura de la pierna" },
  { code: "S83", label: "Luxación y esguince de la rodilla" },
  { code: "S90", label: "Traumatismo superficial del tobillo y del pie" },
  { code: "S92", label: "Fractura del pie" },
  { code: "S93", label: "Luxación y esguince del tobillo y del pie" },
  { code: "T08", label: "Fractura de la columna vertebral, nivel no especificado" },
  { code: "T14", label: "Traumatismo de región del cuerpo no especificada" },
  { code: "T20", label: "Quemadura y corrosión de la cabeza y del cuello" },
  { code: "T21", label: "Quemadura y corrosión del tronco" },
  { code: "T22", label: "Quemadura y corrosión del hombro y del miembro superior" },
  { code: "T30", label: "Quemadura y corrosión, parte del cuerpo no especificada" },
  { code: "T36", label: "Envenenamiento por antibióticos sistémicos" },
  { code: "T39", label: "Envenenamiento por analgésicos, antipiréticos y antirreumáticos" },
  { code: "T42", label: "Envenenamiento por antiepilépticos, hipnóticos y sedantes" },
  { code: "T45", label: "Envenenamiento por agentes que afectan la sangre" },
  { code: "T51", label: "Efecto tóxico del alcohol" },
  { code: "T56", label: "Efecto tóxico de metales" },
  { code: "T60", label: "Efecto tóxico de plaguicidas" },
  { code: "T65", label: "Efecto tóxico de otras sustancias" },
  { code: "T75", label: "Efectos de otras causas externas" },
  { code: "T78", label: "Efectos adversos no clasificados" },

  // ── Cap. XXI: Factores que influyen en la salud (Z00–Z99) ──────────────────
  { code: "Z00", label: "Examen general e investigación de personas sin quejas o diagnóstico" },
  { code: "Z01", label: "Otros exámenes y contactos con los servicios de salud" },
  { code: "Z02", label: "Exámenes para propósitos administrativos" },
  { code: "Z03", label: "Observación y evaluación médica por sospecha de enfermedades" },
  { code: "Z04", label: "Examen y observación por otras razones" },
  { code: "Z08", label: "Examen de seguimiento tras tratamiento de tumor maligno" },
  { code: "Z09", label: "Examen de seguimiento tras tratamiento de otras afecciones" },
  { code: "Z10", label: "Examen de salud general rutinario" },
  { code: "Z11", label: "Examen especial de detección de enfermedades infecciosas" },
  { code: "Z12", label: "Examen especial de detección de tumores" },
  { code: "Z13", label: "Examen especial de detección de otras enfermedades" },
  { code: "Z20", label: "Contacto con enfermedades transmisibles" },
  { code: "Z21", label: "Estado de infección asintomática por VIH" },
  { code: "Z22", label: "Portador de enfermedades infecciosas" },
  { code: "Z23", label: "Necesidad de inmunización contra enfermedades bacterianas" },
  { code: "Z24", label: "Necesidad de inmunización contra ciertas enfermedades virales" },
  { code: "Z25", label: "Necesidad de inmunización contra otras enfermedades virales" },
  { code: "Z29", label: "Necesidad de otras medidas profilácticas" },
  { code: "Z30", label: "Anticoncepción" },
  { code: "Z34", label: "Supervisión de embarazo normal" },
  { code: "Z35", label: "Supervisión de embarazo de alto riesgo" },
  { code: "Z38", label: "Recién nacido vivo según lugar de nacimiento" },
  { code: "Z39", label: "Examen y atención del postparto" },
  { code: "Z47", label: "Otros cuidados ortopédicos de seguimiento" },
  { code: "Z48", label: "Cuidados postquirúrgicos" },
  { code: "Z50", label: "Atención con procedimientos de rehabilitación" },
  { code: "Z51", label: "Otras atenciones médicas" },
  { code: "Z54", label: "Estado de convalecencia" },
  { code: "Z55", label: "Problemas relacionados con la educación y la alfabetización" },
  { code: "Z56", label: "Problemas relacionados con el trabajo y el empleo" },
  { code: "Z57", label: "Exposición ocupacional a factores de riesgo" },
  { code: "Z58", label: "Problemas relacionados con el ambiente físico" },
  { code: "Z59", label: "Problemas relacionados con la vivienda y las circunstancias económicas" },
  { code: "Z60", label: "Problemas relacionados con el ambiente social" },
  { code: "Z61", label: "Problemas relacionados con eventos negativos en la niñez" },
  { code: "Z62", label: "Otros problemas relacionados con la crianza del niño" },
  { code: "Z63", label: "Otros problemas relacionados con el grupo familiar primario" },
  { code: "Z64", label: "Problemas relacionados con ciertas circunstancias psicosociales" },
  { code: "Z65", label: "Problemas relacionados con otras circunstancias psicosociales" },
  { code: "Z71", label: "Personas que contactan los servicios de salud para consulta" },
  { code: "Z72", label: "Problemas relacionados con el estilo de vida" },
  { code: "Z73", label: "Problemas relacionados con dificultad en el manejo de la vida" },
  { code: "Z74", label: "Problemas relacionados con dependencia del proveedor de cuidados" },
  { code: "Z75", label: "Problemas relacionados con recursos médicos" },
  { code: "Z76", label: "Personas que tienen contacto con los servicios de salud" },
  { code: "Z80", label: "Historia familiar de tumores malignos" },
  { code: "Z82", label: "Historia familiar de ciertas discapacidades" },
  { code: "Z85", label: "Historia personal de tumores malignos" },
  { code: "Z86", label: "Historia personal de otras enfermedades" },
  { code: "Z87", label: "Historia personal de otras enfermedades y afecciones" },
  { code: "Z88", label: "Historia personal de alergia a drogas y agentes biológicos" },
  { code: "Z89", label: "Ausencia adquirida de miembros" },
  { code: "Z90", label: "Ausencia adquirida de órganos" },
  { code: "Z95", label: "Presencia de implantes y prótesis cardiovasculares" },
  { code: "Z96", label: "Presencia de otros implantes funcionales" },
  { code: "Z97", label: "Presencia de otros dispositivos" },
  { code: "Z98", label: "Otros estados postquirúrgicos" },
  { code: "Z99", label: "Dependencia de máquinas e instrumentos habilitantes" },
];

export default CIE10;
